import { __assign } from 'tslib';
import * as React from 'react';

var NucleobaseComponentMapContext = React.createContext({});
var useNucleobaseComponentMapContext = function () {
    var overrideMap = React.useContext(NucleobaseComponentMapContext);
    var map = React.useMemo(function () { return (__assign({}, (overrideMap || {}))); }, [overrideMap]);
    return map;
};

export { NucleobaseComponentMapContext, useNucleobaseComponentMapContext };
//# sourceMappingURL=index.esm.js.map
